export default __webpack_public_path__ + "static/media/red-warning-triangle.56b965ac.svg";